import { useDisclaimersContext } from "./DisclaimersContext";
import { compiler } from "markdown-to-jsx";
import "../../../styles/scss/disclaimersV2/disclaimers-popup.scss";

const DisclaimersPopup = () => {
  const {
    activeDisclaimerId,
    resolveDisclaimer,
    disclaimerStatus,
    requestDisclaimers,
    closeDisclaimer,
  } = useDisclaimersContext();

  const text = activeDisclaimerId
    ? resolveDisclaimer(activeDisclaimerId)
    : undefined;
  const status = activeDisclaimerId
    ? disclaimerStatus(activeDisclaimerId)
    : undefined;

  // Global answers arrive on demand, so "no text" has three meanings that must
  // not look alike: still loading, could not be loaded, and genuinely nothing.
  // The last stays an empty popup — copy contains bracketed words that are not
  // disclaimers ([Toyota], [XX]), and the token regex makes those stars.
  let body = null;
  if (text) {
    body = compiler(text);
  } else if (status === "failed") {
    body = (
      <p className="disclaimer-status">
        This disclaimer could not be loaded.{" "}
        <button
          type="button"
          className="disclaimer-retry"
          onClick={() => requestDisclaimers([activeDisclaimerId])}
        >
          Try again
        </button>
      </p>
    );
  } else if (status === "loading") {
    body = (
      <p className="disclaimer-status" role="status">
        Loading…
      </p>
    );
  }

  return (
    <div
      className={`disclaimer-overlay ${activeDisclaimerId ? "show" : ""}`}
      onClick={closeDisclaimer}
    >
      <div className="disclaimer-content" onClick={(e) => e.stopPropagation()}>
        <div className="disclaimer-text">{body}</div>
        <button className="disclaimer-exit" onClick={closeDisclaimer}>
          <div className="disclaimer-exit-name">×</div>
        </button>
      </div>
    </div>
  );
};

export default DisclaimersPopup;
